// repository.ts
import { getApiClient } from '@mit/aws-vue';
import { PersonalInformationApi } from '../api/PersonalInformationApi';

const personalInformationRepository = getApiClient(PersonalInformationApi, 'personal-information@v2');

export default personalInformationRepository;

